<div class="container">
  <app-onboarding-header
    [title]="'Operaciones'"
    [subtitle]="!errorMessage && 'Luego de realizarse el depósito, se realizará la órden.'"
  ></app-onboarding-header>
  <ng-container *ngIf="dataStatus?.status === OPERATION_STATUS.WAITING; else default">
    <app-deposit [dataDeposit]="dataDeposit"></app-deposit>
  </ng-container>
  <ng-template #default>
    @if (loading) {
    <app-loading-manteca></app-loading-manteca>
    } @else {
    <div class="error-container">
      <img class="error" src="assets/icons/error.svg" alt="error" />
      <p [innerHTML]="errorMessage"></p>
    </div>
    }
  </ng-template>
  <app-onboarding-footer
    [positionAbsolute]="dataStatus?.status !== OPERATION_STATUS.WAITING ? true : isDesktop"
    [showButton]="false"
    [privacyPolicy]="false"
  ></app-onboarding-footer>
</div>
